const ALLTIME_INTERVAL = 'all';
const DAILY_INTERVAL = 'daily';
const FIFTEEN_MINUTE_INTERVAL = 'fifteenMinute';
const MONTHLY_INTERVAL = 'monthly';
const NEW_GRAPH_VIEW = 'New Graph';
const OLD_GRAPH_VIEW = 'Old Graph';

export { ALLTIME_INTERVAL, DAILY_INTERVAL, FIFTEEN_MINUTE_INTERVAL, MONTHLY_INTERVAL, NEW_GRAPH_VIEW, OLD_GRAPH_VIEW };
